import { useState } from "react"
import {FaTwitter} from 'react-icons/fa'
import {FaGoogle} from 'react-icons/fa'
import {FaFacebook} from 'react-icons/fa'
import { connect, GoogleProvider, FacebookProvider, SignInEmailAndPassword } from "./Firebase"
import SignUp from "./SignUp"
import { ShakeIt } from "../App"


const Login = () => {
    
    const [userName, setUserName] = useState('')
    const [password, setPassword] = useState('')


    
    

    const onSubmit = (e) => {
        e.preventDefault()

        let states = ['userName', 'password']
        var valid = true
        states.forEach((signUpState) => {
            switch (signUpState){
                case 'userName':
                    if (userName === "") {document.getElementById("login").getElementsByClassName("form-control")[0].firstChild.classList.add('form-required'); valid = false} 
                    else document.getElementsByClassName("form-control")[0].firstChild.classList.remove('form-required')
                    break;
                case 'password':
                    if (password === "") {document.getElementById("login").getElementsByClassName("form-control")[1].firstChild.classList.add('form-required'); valid = false}
                    else document.getElementsByClassName("form-control")[1].firstChild.classList.remove('form-required')
                    break;
                default :
                console.log('No providers')
                break;
            }
        })

        
        // onSignIn()
        if (valid){
            SignInEmailAndPassword(userName, password)
        }else{
            ShakeIt('login')
        }
    }

    

    return (
        <div style={{overflow: 'auto'}} className='fullscreen'>
            <SignUp />
            <div id='login' className="login-form" onSubmit={onSubmit}>
                <h2>Sign In</h2>
                <form>
                    <div className='form-control'>
                        <input type='text' placeholder='USERNAME' value={userName} onChange={(e) => {setUserName(e.target.value)}}/>
                    </div>

                    <div className='form-control'>
                        <input type='password' placeholder='PASSWORD' value={password} onChange={(e) => {setPassword(e.target.value)}}/>
                    </div>
                    
                    <input type='submit' value='Login' className='btn-block' style={{borderRadius:"25px", display:'block', margin:'9vh auto 5% auto'}} />
                    <label style={{color:"#616161", fontWeight:"bold", borderBottom:"1px solid #616161", display:'block', paddingBottom:'20px'}}> Or sign in with:</label>
                    
                    <div className='list-control'>
                        <ul>
                            <li><a><FaTwitter className='sign-in-icons' /></a></li>
                            <li><a><FaFacebook className='sign-in-icons' onClick={() => {connect(FacebookProvider())}}/></a></li>
                            <li><a><FaGoogle className='sign-in-icons' onClick={() => {connect(GoogleProvider())}}/></a></li>
                        </ul>
                    </div>

                    <div className='form-control'>
                        <a style={{display: 'block', marginBottom:'3%', cursor:'pointer'}} onClick={() => {
                            document.getElementById("signUp").classList.remove('hide');
                            setTimeout(() => {
                                document.getElementById("login").style.top = "2500px"; 
                                document.getElementById("signUp").style.top = "0px";
                            }, 1)
                            setTimeout(() => {
                                document.getElementById("login").classList.add('hide');
                            }, 500)
                            
                            var elems = document.querySelectorAll(".form-required");
                            elems.forEach((elem) => {elem.classList.remove('form-required')})
                        }}>Don't have an account yet?</a>
                        <a style={{display: 'block', cursor:'pointer'}}>Forgot password</a>
                    </div>
                </form>
            </div>
        </div>
        
    )
}

export default Login














